import { Main } from "../../Main";
import { Collection } from "../Collection";
import { IInput, IInputConfig } from "./Input";
import { RangeInput } from "./RangeInput";
import { BooleanInput } from "./BooleanInput";
import { NumberInput } from "./NumberInput";
import { ColorSelectInput } from "./ColorSelectInput";
import { EmptyInput } from "./EmptyInput";
import { SelectInput } from "./SelectInput";

export class InputFactory
{
	static createFromConfig(config:IInputConfig):IInput
	{
		var input: IInput;
		var type = config.type;

		if (!type)
		{
			// no type given -> determine by value
			type = typeof config.value;

			if (type === "number" && config['min'] !== undefined && config['max'] !== undefined)
			{
				type = "range";
			}
		}

		switch(type)
		{
			case "boolean":
				input = new BooleanInput(config);
				break;

			case "range":
				input = new RangeInput(config);
				break;

			case "number":
				input = new NumberInput(config);
				break;

			case "color":
				input = new ColorSelectInput(config);
				break;

			case "empty":
				input = new EmptyInput(config);
				break;

			case "select":
				if ((<any>config).values.length > 2)
				{
					if (!((<any>config).values instanceof Collection))
					{
						(<any>config).values = new Collection<any>((<any>config).values);
					}

					input = new SelectInput(config);
				}
				else
				{
					input = new BooleanInput(config);
				}
				
				break;

			default:
				console.log("Error! Type not found:", type);
		}

		input.changeSignal.add(InputFactory.onInputChange, this);

		return input;
	}

	private static onInputChange()
	{
		Main.getInstance().render = true;
	}
}